<template>
    <div class="feedback-detail-container">
      <div class="feedback-detail-header">
        <div class="header-left">
          <div class="feedback-detail-title">
            <div class="feedback-detail-title-text">Feedback</div>
          </div>
          <div class="feedback-detail-name">
            <div class="survey-detail-name-text" v-if="survey.name">
              {{ survey.name }}
            </div>
            <div class="survey-detail-name-text" v-else>No Name</div>
          </div>
        </div>
  
      </div>
  
      <hr class="divider" />
      <div class="feedback-detail-body">
        <p>{{ survey.feedback || 'No feedback available.' }}</p>

      </div>
    </div>
  </template>
  
  <script>
  import Template from "../../../Firestore/Template.js";
  import Response from "../../../Firestore/Response.js";
  
  export default {
    name: "SurveyDetails",
    components: {
      Template
    },
    data() {
      return {
        openQuestions: []
      };
    },
    props: {
      survey: {
        type: Object
      }
    },
    methods: {
      toggleQuestion(index) {
        if (this.openQuestions.includes(index)) {
          this.openQuestions = this.openQuestions.filter(i => i !== index);
        } else {
          this.openQuestions.push(index);
        }
      },
      publishSurvey() {
        Response.assignSurveyToAll(this.survey.sID, this.survey.gameID)
          .then(() => {
            this.survey.status = 1;
          })
          .catch(e => console.log(e));
      },
      archiveSurvey() {
        Template.setSurveyStatus(this.survey.sID, 2)
          .then(() => {
            this.survey.status = 2;
          })
          .catch(e => console.log(e));
      },
      formatQType(qtype) {
        const formattedQType = qtype
          .split("-")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
  
        return formattedQType;
      },
      processQuestionContent(question) {
        switch (question.qType) {
          case "multi-choice":
            //Return an array containing each text within question.content.options
            return question.content.options.map(option => option.text);
          case "multi-select":
            return question.content.options;
          case "dropdown":
            return question.content.options;
          case "text-answer":
            return ["Text Answer"];
          case "linear-scale":
            return [question.content.startLabel, question.content.endLabel];
          default:
            return [];
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .feedback-detail-container {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
  }
  
  .feedback-detail-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 10%;
    min-height:10%;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
  }
  
  .header-left {
    margin-left: 5%;
    display: flex;
    flex-direction: row;
  }
  .header-right {
    margin-right: 2.5%;
    display: flex;
    flex-direction: row;
  }
  .feedback-detail-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    /* width: 50%; */
    align-items: center;
    justify-content: center;
  }
  .feedback-detail-title-text {
    font-weight: bold;
    font-size: 24px;
    line-height: 46px;
    color: #fc7727;
    vertical-align: bottom;
  }
  .feedback-detail-name {
    font-style: italic;
    font-weight: bold;
    margin-left: 10px;
    margin-top: 15px;
    color: #909090;
    vertical-align: bottom;
  }
  .survey-detail-buttons {
    float: right;
  }
  .survey-detail-button{
    background-color: #fc7727 !important;
    color: #fff;
    border: none;
    border-radius: 10px !important;
    padding: 0.25rem 0.5rem;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
  }
  .survey-detail-button:hover{
    background-color: #ff8e4d !important;
  }
  .divider {
    border: 1px solid #c2c2c2;
    width: 95%;
    margin: 0 auto;
  }
  .survey-detail-subtitle {
    font-size: 20px;
    line-height: 46px;
    color: #fc7727;
    margin-top: 5px;
  }
  .feedback-detail-body {
    margin-left: 5%;
    margin-right: 5%;
  }
  
  .survey-detail-description-text {
    color: #bebebe;
  }
  .tag-container {
    display: flex;
    flex-wrap: wrap;
  }
  
  .tag-capsule {
    background-color: #db3360;
    color: white;
    border-radius: 10px;
    padding: 5px 10px;
    margin-right: 8px;
    margin-bottom: 5px;
    box-shadow: 0px 4px 10px rgba(219, 51, 96, 0.3);
  }
  .question-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
    margin-bottom: 10px;
    margin-top: 10px;
    cursor: pointer;
    
  }
  .qheader-left {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    width: 70%;
    align-items: center;
    justify-content: flex-start;
  }
  .qheader-right {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    width: 30%;
    align-items: center;
    justify-content: flex-end;
  }
  .question-title {
    margin-left: 5px;
  }
  .question-type {
    font-style: italic;
    margin-right: 10px;
    color: #bebebe;
    vertical-align: bottom;
  }
  
  .question-body{
    margin-left: 20px;
    margin-bottom: 5px;
  }
  
  .question-content-container {
    display: flex;
    flex-direction: column;
  }
  
  .question-content {
    display: flex;
    align-items: flex-start;
    margin-left: 20px; /* Adjust the margin as needed */
  }
  
  .question-content::before {
    /* content: '•'; */
    margin-right: 5px; /* Adjust the margin as needed */
  }
  </style>


// WEBPACK FOOTER //
// src/components/game-detail/Surveys/Feedback.vue